function getPart(parts: Intl.DateTimeFormatPart[], type: Intl.DateTimeFormatPartTypes) {
	return parts.find((part) => part.type === type)?.value || "";
}

export function formatOrderCreatedAtForStation(createdAt: string | Date | null | undefined, timeZoneId?: string | null) {
	if (!createdAt) return "";

	const date = createdAt instanceof Date ? createdAt : new Date(createdAt);
	if (Number.isNaN(date.getTime())) return "";

	const options: Intl.DateTimeFormatOptions = {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
		hour12: false,
	};

	const tz = String(timeZoneId || "").trim();
	try {
		const formatter = new Intl.DateTimeFormat("en-GB", tz ? { ...options, timeZone: tz } : options);
		const parts = formatter.formatToParts(date);
		const hour = getPart(parts, "hour");
		const minute = getPart(parts, "minute");
		const day = getPart(parts, "day");
		const month = getPart(parts, "month");
		const year = getPart(parts, "year");

		if (!hour || !minute || !day || !month || !year) return formatter.format(date);
		return `${hour}:${minute} ${day}-${month}-${year}`;
	} catch {
		const formatter = new Intl.DateTimeFormat("en-GB", options);
		const parts = formatter.formatToParts(date);
		const hour = getPart(parts, "hour");
		const minute = getPart(parts, "minute");
		const day = getPart(parts, "day");
		const month = getPart(parts, "month");
		const year = getPart(parts, "year");
		return `${hour}:${minute} ${day}-${month}-${year}`;
	}
}
